<template>
  <div class="footer-sns">
    <hr class="c-hr-contents-area mb20">
    <div class="double">
      <table>
        <tr>
          <td class="facebook-container" valign="top">
            <div class="test">
              <Facebook size="500"/>
            </div>
          </td>
          <td class="tw-container" valign="top">
            <Twitter/>
          </td>
        </tr>
      </table>
    </div>
    <div class="single">
      <div class="inner">
        <Facebook width="320"/>
      </div>
      <div class="inner">
        <Twitter/>
      </div>
    </div>
  </div>
</template>

<script>

/* コンポーネントの登録 */
import Facebook from '@/components/common/Facebook'
import Twitter from '@/components/common/Twitter'

export default {
  components: {
    Facebook,
    Twitter
  }
}

</script>

<style lang="scss" scoped>

  // 801以上
  @media screen and (min-width: 801px) {
    .double {
      display: block;
    }
    .single {
      display: none;
    }

    .footer-sns {
      width: 900px;
      margin: 0 auto;
      background: #fff;
    }

    .facebook-container {
      width: 500px;
      padding: 4px;
    }

    .tw-container {
      width: 400px;
      padding: 4px;
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {
    .double {
      display: none;
    }
    .single {
      display: block;
      width: 320px;
    }

    .footer-sns {
      margin: 10px auto;
      padding: 15px;
      background: #fff;
    }

    .facebook-container {
      padding: 4px;
    }

    .tw-container {
      padding: 4px;
    }
  }

  .single {
    .inner {
      text-align: center;
      margin: 0 auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/FooterSns.vue